import type { ThemeConfig } from 'antd';
import { BLUE, DANGER, GREEN, PRIMARY, YELLOW } from './palette';

export const themeConfig: ThemeConfig = {
  token: {
    // Colors
    colorPrimary: PRIMARY,
    colorLink: PRIMARY,
    // The palette (see palette.ts) is the only source of semantic colours. antd's own preset colours
    // (what `color="green"` on a Tag, Badge or Alert resolves to) are re-seeded from it, so even a
    // stock preset comes out in our family.
    blue: BLUE.badge,
    green: GREEN.badge,
    gold: YELLOW.badge,
    orange: YELLOW.badge,
    red: DANGER.badge,
    colorInfo: BLUE.badge,
    colorSuccess: GREEN.tag,
    colorSuccessHover: GREEN.badge,
    colorSuccessActive: GREEN.active,
    colorSuccessBg: GREEN.soft,
    colorSuccessBgHover: GREEN.card,
    colorSuccessBorder: GREEN.card,
    colorWarning: YELLOW.badge,
    colorWarningHover: YELLOW.tag,
    colorWarningActive: YELLOW.active,
    colorWarningBg: YELLOW.soft,
    colorWarningBgHover: YELLOW.card,
    colorWarningBorder: YELLOW.card,
    colorError: DANGER.tag,
    colorErrorHover: DANGER.badge,
    colorErrorActive: DANGER.active,
    colorErrorBg: DANGER.soft,
    colorErrorBgHover: DANGER.card,
    colorErrorBorder: DANGER.card,
    colorErrorBorderHover: DANGER.badge,
    colorTextHeading: 'rgba(0, 0, 0, 0.85)',
    colorText: 'rgba(0, 0, 0, 0.65)',
    colorTextSecondary: 'rgba(0, 0, 0, 0.45)',
    colorTextDisabled: 'rgba(0, 0, 0, 0.25)',
    colorBorder: '#d9d9d9',
    colorBgLayout: '#ffffff',

    // Typography
    fontFamily: "'Mulish', sans-serif",
    fontSizeHeading1: 32,
    fontSizeHeading2: 24,
    fontSizeHeading3: 20,
    fontSizeHeading4: 16,
    fontSizeHeading5: 14,
    fontSizeSM: 12,
    lineHeight: 1.5715,

    // Spacing (4px base scale: 4, 8, 12, 16, 24, 32, 48)
    marginXS: 4,
    marginSM: 8,
    margin: 12,
    marginMD: 16,
    marginLG: 24,
    marginXL: 32,
    marginXXL: 48,
    paddingXS: 4,
    paddingSM: 8,
    padding: 12,
    paddingMD: 16,
    paddingLG: 24,
    paddingXL: 32,

    // Shape
    borderRadius: 8,
    boxShadow:
      '0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05)',
  },
};
